"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.setUserPostalCodeInDealerCache = exports.setParamsForClickshopUrl = exports.setDealerPostalCodeInDealerCache = exports.setCachedDealerSearch = exports.getCachedDealerSearch = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var DEALER_CACHE_KEY = 'cSL_csDL';
var defaultState = {
  userPostalCode: '',
  dealerPostalCode: ''
};
var localStorage = typeof window !== 'undefined' && window.localStorage;
var getCachedDealerSearch = function getCachedDealerSearch() {
  if (!localStorage || !localStorage.getItem(DEALER_CACHE_KEY)) {
    return defaultState;
  }
  return JSON.parse(localStorage.getItem(DEALER_CACHE_KEY));
};
exports.getCachedDealerSearch = getCachedDealerSearch;
var setCachedDealerSearch = function setCachedDealerSearch(data) {
  if (!localStorage) {
    return;
  }
  if (data) {
    return localStorage.setItem(DEALER_CACHE_KEY, JSON.stringify(data));
  }
  localStorage.removeItem(DEALER_CACHE_KEY);
};
exports.setCachedDealerSearch = setCachedDealerSearch;
var setUserPostalCodeInDealerCache = function setUserPostalCodeInDealerCache(userPostalCode) {
  var cachedDealerSearch = getCachedDealerSearch();
  var dealerInfo = _objectSpread(_objectSpread({}, cachedDealerSearch), {}, {
    userPostalCode: userPostalCode
  });
  setCachedDealerSearch(dealerInfo);
};
exports.setUserPostalCodeInDealerCache = setUserPostalCodeInDealerCache;
var setDealerPostalCodeInDealerCache = function setDealerPostalCodeInDealerCache(dealerPostalCode) {
  var cachedDealerSearch = getCachedDealerSearch();
  var dealerInfo = _objectSpread(_objectSpread({}, cachedDealerSearch), {}, {
    dealerPostalCode: dealerPostalCode
  });
  setCachedDealerSearch(dealerInfo);
};
exports.setDealerPostalCodeInDealerCache = setDealerPostalCodeInDealerCache;
var setParamsForClickshopUrl = function setParamsForClickshopUrl(url) {
  var formattedUrl = new URL(url);
  if (!formattedUrl.searchParams.get('location')) {
    var cachedDealerQuery = getCachedDealerSearch();
    var postalCode = cachedDealerQuery.dealerPostalCode ? cachedDealerQuery.dealerPostalCode : cachedDealerQuery.userPostalCode;
    if (postalCode) {
      formattedUrl.searchParams.set('location', postalCode);
      formattedUrl.hash = 'openDealershipFilter';
    }
  }
  return formattedUrl;
};
exports.setParamsForClickshopUrl = setParamsForClickshopUrl;